/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {DictionaryItem} from '../models/DictionaryItem';
import type {Error} from '../models/Error';

export interface GetLicenseFeatures$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getLicenseFeaturesRequest = createAction<PayloadData<void>>('GET_LICENSE_FEATURES__GET_LICENSE_FEATURES__REQUEST');
export const getLicenseFeaturesSuccess = createAction<PayloadData<Array<DictionaryItem>>>('GET_LICENSE_FEATURES__GET_LICENSE_FEATURES__SUCCESS');
export const getLicenseFeaturesFailure = createAction<PayloadData<Error, void, true>>('GET_LICENSE_FEATURES__GET_LICENSE_FEATURES__FAILURE');

export const getLicenseFeaturesActions = [
    getLicenseFeaturesRequest,
    getLicenseFeaturesSuccess,
    getLicenseFeaturesFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getLicenseFeatures = (config?: GetLicenseFeatures$Config) => {
    return {
        CALL_API: {
            types: getLicenseFeaturesActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/dictionaries/license-features`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

